// ai_setting Redux reducer
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_AI_SETTING_VISIBLE, SET_AI_SETTING_SETTINGS, SET_AI_SETTING_CURRENT, SET_AI_SETTING_LOADING, SET_AI_SETTING_SAVING, SET_AI_SETTING_ERROR, ADD_AI_SETTING, UPDATE_AI_SETTING, REMOVE_AI_SETTING } from './actions';
const DEFAULT_STATE = {
    visible: false,
    settings: [],
    currentSetting: null,
    loading: false,
    saving: false,
    error: null
};
ReducerRegistry.register('features/ai_setting', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_AI_SETTING_VISIBLE:
            return {
                ...state,
                visible: action.visible
            };
        case SET_AI_SETTING_SETTINGS:
            return {
                ...state,
                settings: action.settings,
                loading: false,
                error: null
            };
        case SET_AI_SETTING_CURRENT:
            return {
                ...state,
                currentSetting: action.setting
            };
        case SET_AI_SETTING_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case SET_AI_SETTING_SAVING:
            return {
                ...state,
                saving: action.saving
            };
        case SET_AI_SETTING_ERROR:
            return {
                ...state,
                error: action.error,
                loading: false,
                saving: false
            };
        case ADD_AI_SETTING:
            return {
                ...state,
                settings: [...state.settings, action.setting],
                saving: false,
                error: null
            };
        case UPDATE_AI_SETTING:
            return {
                ...state,
                settings: state.settings.map(setting => setting.id === action.setting.id ? action.setting : setting),
                currentSetting: action.setting,
                saving: false,
                error: null
            };
        case REMOVE_AI_SETTING:
            return {
                ...state,
                settings: state.settings.filter(setting => setting.id !== action.id),
                currentSetting: state.currentSetting?.id === action.id ? null : state.currentSetting,
                error: null
            };
        default:
            return state;
    }
});
